<template lang="pug">
  div
    section.content-header
      h1 操作ログ詳細

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li
          router-link(:to="{name: 'AccessLog'}") 操作ログ
        li.active 操作ログ詳細

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      mixin btnbar
        .bcard-btnbar(class!=attributes.class)
          router-link.btn.btn-default(:to="{name: 'AccessLog'}" title="戻る"): i.fa.fa-reply

      +btnbar

      .box.box-widget

        .box-body
          .form-group
            label.control-label 操作日時
            .form-control-static {{item.formatted_datetime}}

          .form-group
            label.control-label 操作内容
            .form-control-static {{item.lang_category}}

          .form-group
            label.control-label 操作ユーザー
            .form-control-static(v-if="!item.target_user.id") {{item.target_user.full_name}}
            .form-control-static(v-else) [{{item.target_user.id}}] {{item.target_user.full_name}}

          .form-group(v-if="item.login_user")
            label.control-label 代理操作ユーザー
            .form-control-static(v-if="!item.login_user.id") {{item.login_user.full_name}}
            .form-control-static(v-else) [{{item.login_user.id}}] {{item.login_user.full_name}}

          .form-group
            label.control-label ログ
            .form-control-static
              pre: code {{item.log}}

          .form-group(v-if="item.lang_category === '名刺情報のエクスポート'")
            label ダウンロード
            .form-control-static
              button.btn.btn-success.btn-sm(type="button" @click="download()")
                i.fa.fa-fw.fa-download
                |
                |
                | エクスポートファイル
          .form-group(v-if="item.lang_category === '名刺情報のインポート'")
            label ダウンロード
            .form-control-static
              button.btn.btn-success.btn-sm(type="button" @click="download()")
                i.fa.fa-fw.fa-download
                |
                |
                | インポートファイル

      +btnbar.-bottom
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AccessLogRepository = RepositoryFactory.get('accesslogs')

export default {
  name: 'AccessLogDetails',
  components: { AppMessages },
  props: {
    id: {
      type: [String, Number],
      required: false,
      default: 0
    },
    item: {
      type: Object,
      required: false,
      default: function () {
        return {
          lang_category: '',
          target_user: ''
        }
      }
    }
  },
  data () {
    return {
      initLoading: false,
      isDownloading: false // ダウンロード中
    }
  },
  created: function () {
    if (this.id) {
      this.initLoading = true
      // 対象データ取得
      const vm = this
      AccessLogRepository.get(this.id)
        .then(function (response) {
          const data = vm.getApiData(response).data

          vm.item.formatted_datetime = data.formatted_datetime
          vm.item.lang_category = data.lang_category
          vm.item.target_user = data.target_user
          vm.item.login_user = data.login_user
          vm.item.log = data.log
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
        .finally(function () {
          vm.initLoading = false
        })
    }
  },
  methods: {
    /**
     * 実ファイルダウンロード
     */
    download: function () {
      const vm = this
      // ダウンロード中ではない場合のみ実行する
      if (this.isDownloading === false) {
        this.isDownloading = true

        this.getFileDL('accesslogs', 'logDownload', 'access_log_' + this.id + '.csv', this.id)
          .catch(function (error) {
            vm.setErrorMessage(error)
          })
          .finally(function () {
            vm.isDownloading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/accesslog/Details.vue